import React, { useCallback } from 'react';
import {
  PropertyConfiguration,
  PropertyConfigurationForms,
  propertyConfigurationService,
  ThermostatMode,
} from 'app/state';
import { FormHub, useFormEvents } from '@lib/common';
import {
  PropertyIoTSettingsFormFields,
  PropertyIoTSettingsForm,
} from './property-iot-settings.form';

interface Props {
  property: PropertyConfiguration;
}

export const ManagePropertyIoTSettingsComponent: React.FC<Props> = ({ property }) => {
  const [{ status, error }, resetUI] = useFormEvents(PropertyConfigurationForms.Update);

  const submit = useCallback(
    ({
      minTemperature,
      maxTemperature,
      defaultTemperature,
      defaultThermostatMode,
      temperatureOffset,
      awayMinTemperatureF,
      awayMaxTemperatureF,
      awayOffsetF,
      awayBehavior,
      vacantMinTemperatureF,
      vacantMaxTemperatureF,
      vacantBehavior,
    }: PropertyIoTSettingsFormFields) => {
      propertyConfigurationService.updatePropertyIoTSettings(property.id, {
        minTemperature: minTemperature ?? 0,
        maxTemperature: maxTemperature ?? 0,
        defaultTemperature: defaultTemperature ?? 0,
        defaultThermostatMode: defaultThermostatMode ?? ThermostatMode.HEATCOOL,
        temperatureOffset: temperatureOffset ?? 0,
        awayMinTemperatureF,
        awayMaxTemperatureF,
        awayOffsetF,
        awayBehavior,
        vacantMinTemperatureF,
        vacantMaxTemperatureF,
        vacantBehavior,
      });
    },
    [property]
  );

  return (
    <FormHub<PropertyIoTSettingsFormFields>
      formOptions={{
        defaultValues: {
          minTemperature: property.minTemperature,
          maxTemperature: property.maxTemperature,
          defaultTemperature: property.defaultTemperature,
          defaultThermostatMode: property.defaultThermostatMode,
          temperatureOffset: property.temperatureOffset,
          awayMinTemperatureF: property.awayMinTemperatureF ?? undefined,
          awayMaxTemperatureF: property.awayMaxTemperatureF ?? undefined,
          awayOffsetF: property.awayOffsetF ?? undefined,
          vacantMinTemperatureF: property.vacantMinTemperatureF ?? undefined,
          vacantMaxTemperatureF: property.vacantMaxTemperatureF ?? undefined,
          awayBehavior: property.awayBehavior,
          vacantBehavior: property.vacantBehavior,
        },
      }}
      onSubmit={submit}
    >
      <PropertyIoTSettingsForm status={status} error={error} resetUI={resetUI} />
    </FormHub>
  );
};
